module.exports = __webpack_public_path__ + "img/3.00747eb6.jpg";